import Panel from "@src/components/box/Panel";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const AuthWrapper = ({ children }: Props) => <Panel mobileBorder={false}>{children}</Panel>;

export default AuthWrapper;
